// My custom script for animating elements on scroll (not the AOS lib).
//
// INSTRUCTIONS
// - Add "data-aos" attribute to element you want to animate. The value for this attribute
//   should be a Animate.css class (https://animate.style/). Example: data-aos="animate__fadeInUp"
//
// - Optional: add a data-aos-delay attribute to control when the element will start animating
//   when scrolled into view. Value in milliseconds.
//
// - Optional: add a data-aos-speed attribute to control animation speed. Valid values are the speed
//   classes from Animate.css: 'animate__slow', 'animate__slower', 'animate__fast', 'animate__faster'

window.addEventListener('load', () => {      
  identifyAnimatedElements();
});

function identifyAnimatedElements() {
  let animatedElements = document.querySelectorAll('[data-aos]');

  let animatedElementsObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {

        // Check for a delay data attribute
        if (entry.target.dataset.hasOwnProperty('aosDelay')) {
          setTimeout(() => {
            animateThis(entry.target, animatedElementsObserver);             
          }, entry.target.dataset.aosDelay);

        } else {
          animateThis(entry.target, animatedElementsObserver);
        }

      }
    });
  }, {});

  animatedElements.forEach(element => {
    animatedElementsObserver.observe(element);  
  });  
}
  
// Animate the element using Animate.css classes
function animateThis(element, animatedElementsObserver) {
    
  // Check for a speed data attribute
  if (element.dataset.aosSpeed) {
    element.classList.add(element.dataset.aosSpeed);  
  }    
    
  element.classList.add('animate__animated', element.dataset.aos); 
  animatedElementsObserver.unobserve(element);
}